import React from "react";
import { withTranslation } from "react-i18next";
import { DocumentTrackingView } from "../../views";
import {
  LocalStorageService,
  EventBinnacleService,
} from "../../../services/index";
import { process as processKendo } from "@progress/kendo-data-query";
import { withRouter } from "react-router";
import moment from "moment";
import "moment/locale/es";
import { ModalBuyCredits } from "../../pures";

class DocumentTrackingAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      eventsBinnacle: [], // Arreglo original de datos
      documents: [],
      events: [], // Arreglo de datos mostrados en cada pagina del Grid
      signRequest: {},
      fileNameDoc: "",
      skip: 0,
      take: 6, // Número de elementos por pagina en Grid
      total: 0,
      group: "",
      sort: [],
      hasContract: true,
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  eventBinnacleService = new EventBinnacleService(this.url);
  title = this.props.t("signatureRequestDetailView2.buttonDocumentTracking") ?? "Bitácora de eventos"

  async componentDidMount() {
    this.setState({ loading: true });
    try {
      let signRequest = this.props.location.params.dataItem;
      this.token =
        this.localStorageService.getLocalStorageItem("token").idToken;
      if (signRequest?.contactExistFlag) {
        this.setState({ hasContract: signRequest.contactExistFlag })
      }

      //Get timezone from navegator
      let navegatorTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let eventsBinnacle

      if (signRequest.inboxTypeId < 4) {
        eventsBinnacle =
          await this.eventBinnacleService.getSignRequestBinnacle(
            signRequest.solicitudeId,
            navegatorTimezone,
            this.token
          );
      } else {
        eventsBinnacle =
          await this.eventBinnacleService.getContractAndContractorBinnacle(
            navegatorTimezone,
            signRequest.workflowExecutionId,
            this.token
          );
      }
      //Get all events of sign request
      moment.locale("es");

      let fileName = "";
      let documents = []
      eventsBinnacle = eventsBinnacle.map((signRequest) => {
        let nameSigner =
          signRequest.user.data.firstName +
          " " +
          signRequest.user.data.firstLastName;
        signRequest.nameSigner = nameSigner;

        let signDocuments = signRequest.eventBinnacle.signRequest.signDocuments;

        if (signDocuments && signDocuments.length > 0) {
          for (let index = 0; index < signDocuments.length; index++) {
            const element = signDocuments[index];
            if (!documents.includes(element)) {
              documents.push(element);
            }
          }
        } else {
          let document =
            signRequest.eventBinnacle.signRequest.documentPath.split("/");
          signRequest.nameDocument = document[document.length - 1];
          fileName = document[document.length - 1];
        }

        let convertedDate = new Date(signRequest.eventBinnacle.executionDateText);
        let day = convertedDate.getDate();
        let month = convertedDate.getMonth() + 1;
        let year = convertedDate.getFullYear();
        let hours = convertedDate.getHours();
        let minutes = convertedDate.getMinutes();
        let seconds = convertedDate.getSeconds();

        if (month === 1) {
          month = "ene";
        } else if (month === 2) {
          month = "feb";
        } else if (month === 3) {
          month = "mar";
        } else if (month === 4) {
          month = "abr";
        } else if (month === 5) {
          month = "may";
        } else if (month === 6) {
          month = "jun";
        } else if (month === 7) {
          month = "jul";
        } else if (month === 8) {
          month = "ago";
        } else if (month === 9) {
          month = "sep";
        } else if (month === 10) {
          month = "oct";
        } else if (month === 11) {
          month = "nov";
        } else if (month === 12) {
          month = "dic";
        }

        day = day >= 10 ? `${day}` : `0${day}`;
        minutes = minutes >= 10 ? minutes : `0${minutes}`;
        seconds = seconds >= 10 ? seconds : `0${seconds}`;

        const dateAndHour = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        let dateToShow = signRequest && signRequest.eventBinnacle && signRequest.eventBinnacle.executionDateText ? signRequest.eventBinnacle.executionDateText : ''
        signRequest.dateAndHour = dateToShow;

        return signRequest;
      });

      this.setState(
        {
          loading: false,
          events: eventsBinnacle.slice(
            this.state.skip,
            this.state.skip + this.state.take
          ),
          total: eventsBinnacle.length,
          eventsBinnacle,
          signRequest,
          documents,
          fileNameDoc: fileName,
        },
        () => {
          this.onChangeFooterInfoPagination(
            this.state.eventsBinnacle,
            this.state.take,
            this.state.skip
          );
        }
      );
    } catch (error) {
      this.props.history.push("/");
      return;
    }
  }

  /**
   * @author Alan Aguilar
   * @updatedDate 01-05-2022
   * @description Filter an array of signRequest and filter by dataState props
   * @param {Object} dataState
   * @memberof DocumentTrackingAction
   */
  processNewState = (dataState) => {
    let response = processKendo(this.state.eventsBinnacle.slice(0), dataState);
    return {
      events: response.data,
      total: response.total,
    };
  };

  /**
   * @author Alan Aguilar
   * @updatedDate 01-05-2022
   * @description Change the data information in the table adding sortable props
   * @param {Object} event
   * @memberof DocumentTrackingAction
   */
  dataStateChange = (event) => {
    let { events, total } = this.processNewState(event.dataState);
    this.setState(
      {
        events,
        total,
        filter: event.dataState.filter ? event.dataState.filter : undefined,
        group: event.dataState.group ? event.dataState.group : undefined,
        sort: event.dataState.sort ? event.dataState.sort : [],
        skip: event.dataState.skip,
        take: event.dataState.take,
      },
      () => {
        this.onChangeFooterInfoPagination(
          this.state.eventsBinnacle,
          this.state.take,
          this.state.skip
        );
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @updatedDate 01-05-2022
   * @description Change the rendering of a custom footer in the grid
   * @param {Array} elements
   * @param {Number} take
   * @param {Number} skip
   * @memberof DocumentTrackingAction
   */
  onChangeFooterInfoPagination = (elements, take, skip) => {
    let showPagination = false;
    let paginationInfoExist = document.querySelector(
      "#infoPaginationSignRequestReceive"
    );

    if (paginationInfoExist) {
      paginationInfoExist.remove();
      showPagination = false;
    }

    let totalItemsInTable = elements.length;

    if (elements.length !== 0) {
      showPagination = { info: false };
      let currentPage = Math.floor(skip / take) + 1;
      let totalPages = Math.ceil((totalItemsInTable || 0) / take);

      let firstItemInPage = skip + 1;
      let lastItemInPage = 0;
      if (currentPage === totalPages) {
        lastItemInPage = totalItemsInTable;
      } else {
        lastItemInPage = skip + take;
      }

      let footerPagination = document.querySelector("div[role='navigation']");
      if (footerPagination) {
        let element = document.createElement("div");
        element.id = "infoPaginationSignRequestReceive";
        element.innerHTML = `<span style="font-family: Quicksand, sans-serif">${firstItemInPage} - ${lastItemInPage} de ${totalItemsInTable} Eventos</span> <span style="margin-left: 30px; font-family: Quicksand, sans-serif;">${currentPage}/${totalPages}</span>`;
        element.className = "k-pager-info k-label";
        footerPagination.appendChild(element);
      }
    } else {
      showPagination = false;
    }

    return showPagination;
  };

  onBack = () => {
    this.props.history.goBack()
  }

  render() {
    if (this.state.hasContract === false) {
      return (
        <ModalBuyCredits />
      );
    } else {
      return (
        <DocumentTrackingView
          {...this.state}
          title={this.title}
          dataStateChange={this.dataStateChange}
          onBack={this.onBack}
        />
      );
    }
  }
}

export default withRouter(withTranslation()(DocumentTrackingAction));
